import { render, staticRenderFns } from "./ArchivedCases.vue?vue&type=template&id=678ca5f2"
import script from "./ArchivedCases.vue?vue&type=script&lang=js"
export * from "./ArchivedCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports